import React from "react";
import _ from "lodash";
import styled from "styled-components";
import { connect } from "react-redux";
import { compose } from "redux";
import { Grid, TextField, Select, MenuItem, Checkbox, FormControl, FormControlLabel } from "@material-ui/core";
import { getContactsByCompany } from "store/state/contacts";
import {getCompaniesByTypeId} from 'store/state/companies';
import { withStyles } from "@material-ui/core/styles";
import companyTypes from "constants/companyTypes";
import inputComponentMask from "../../../../../lib/inputMask";
import { UnstyledDateField } from "../../../../Global/Fields/Date";
import SectionHeader from "./SectionHeader";
import { Edit, Close } from "@material-ui/icons";
import { PrimaryButton, SecondaryButton } from "components/Global/Buttons";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
  } from "@material-ui/core";
  
import { VersitileInput } from "components/Global/Fields/VersitileInput";

const LB_BLUE = "#2196f3";


const StyledDialogIconButton = styled(IconButton)`
  && {
    position: absolute;
    top: 8px;
    right: 13px;
  }
`;

const GreyBox = styled.div `
  background-color: #eeeeee;
  color: #777777;
  border-radius: 3px;
  padding-top: 15px;
  padding-bottom: 15px;
  font-size: 15px;
  vertical-align: middle;
  padding-left: 10px;
  text-align: left;
`;

const styles = () => ({
  inputField: {
    borderBottom: "1px solid #2196F3",
    "&:focused": {
      borderBottom: "1px solid #006dab"
    }
  },
  labelRoot: {
    fontSize: "17px"
  }
});


class OwnershipSection extends React.Component {

componentDidMount () {
    this.props.getContactsByCompany({companyId: this.props.authentication.user.contact.company.id});
    this.props.getCompaniesByTypeId({subKey: "ownershipSection", companyTypeId: companyTypes.SPONSOR});
}

getPotentialContacts = () => {
    if(!this.props.potentialContacts) return [];
    return this.props.potentialContacts[this.props.authentication.user.contact.company.id] || [];
}
getPotentialCompanies = () => {
    return this.props.potentialCompanies || [];
}

state = {
    isAddDialogOpen: false,  
    tempRecord: {principleType:"company"}, 
    showErrorOnModal: false,
}

getOwnershipRecords = () => {
    return this.props.values.ownershipRecords || [];
}

addOwnershipRecord = (formik, record, overrideValidation) => {
    let toAdd = {tempId: Math.floor(Math.random()*99999999), ...record};
    toAdd.isExternalEquitySource = !!toAdd.isExternalEquitySource;
    if(overrideValidation || this.isRecordValid(toAdd)){
        let newList = _.cloneDeep(this.getOwnershipRecords());
        newList.push(toAdd);
        this.props.handleChange(   
            {
              target:
              {
                name: "ownershipRecords",
                value: newList,
              }
            })
        return true;
    } else {
        return false;
    }
}

deleteOwnershipRecord = (formik, record) => {
    let newList = null;
    if(record.id) {
        newList = this.getOwnershipRecords().filter(x=> x.id!=record.id);
    } else if (record.tempId){ //tempIds are given to records not yet saved to db
        newList = this.getOwnershipRecords().filter(x=> !x.tempId || x.tempId!=record.tempId);
    }
    this.props.handleChange(   
        {
          target:
          {
            name: "ownershipRecords",
            value: newList,
          }
        })
}

openAddRecordDialog = () => {
    this.setState({isAddDialogOpen: true});
}

addBlankCompany = () => {
    let newRecord = {principleType: "company", ownershipPercentage: 0};
    this.addOwnershipRecord(null, newRecord, true);
}

addBlankIndividual = () => {
    let newRecord = {principleType: "individual", ownershipPercentage: 0};
    this.addOwnershipRecord(null, newRecord, true);
}

render (){
  const { handleChange, values } = this.props; // formik props
  const { classes } = this.props;
  let companyOwnerRecords = this.getOwnershipRecords().filter(x=>x.principleType=="company");
  let individualOwnerRecords = this.getOwnershipRecords().filter(x=>x.principleType=="individual");
   
  return (
    <div style={{verticalAlign: "top"}}>
      <SectionHeader>Ownership</SectionHeader>
      {this.getOwnershipRecords().length > 0 && this.getSumOfOwnershipPercentages() != 1 && !!this.props.canShowErrors &&
          <>
          <span style={{color: "red"}}>Percentages Do Not Equal 100%</span>
          </>
      }
      {this.getOwnershipRecords().map(x=>x.principleType=="company" && this.renderSlideForRecord(null, x) )}
      {companyOwnerRecords.length === 0 && <GreyBox>No Company Owners Set</GreyBox>}
      <br/>
      <SecondaryButton onClick={()=>{this.addBlankCompany()}}>+ Add Company Owner</SecondaryButton>
      <br/>
      {this.getOwnershipRecords().map(x=>x.principleType=="individual" && this.renderSlideForRecord(null, x) )}
      {individualOwnerRecords.length === 0 && <GreyBox>No Individual Owners Set</GreyBox>}
      <br/>
      <SecondaryButton onClick={()=>{this.addBlankIndividual()}}>+ Add Individual Owner</SecondaryButton>
      {this.renderAddDialog(this.props)}
    </div>
  );
};

renderSlideForRecord = (formik, record) => {
    let type = record.principleType;
    return (
        <div style = {{display: "inline-block", minWidth: "51%", minHeight: "40px", margin: "5px", fontSize: "16px"}}>
            <div style={{float:"right", color:LB_BLUE}}><Close style={{cursor: "pointer", marginTop: "10px"}} onClick={()=>this.deleteOwnershipRecord(formik, record)} /></div>
            <FormControl style={{minWidth: "250px"}}>
            <Select
                    value={record.principleOwnerId}
                    onChange = {(e) => {
                            this.updateExistingRecord(record, "principleOwnerId", e.target.value);
                            }}>   
                {type=="company" && this.getPotentialCompanies().map(x=><MenuItem value={x.id}>{x.name}</MenuItem>)}
                {type=="individual" && this.getPotentialContacts().map(x=><MenuItem value={x.id}>{x.firstName} {x.lastName}</MenuItem>)} 
            </Select>
            </FormControl>
            <VersitileInput 
             type = "percentNoDecimal"
             value = {record.ownershipPercentage*100}
             style={{maxWidth: "80px", marginLeft: "40px"}}
             onChange = {value => {
                 this.updateExistingRecord(record, "ownershipPercentage", value/100);
             }}
            />
            <FormControlLabel
            position= "left"
            value = {!!record.isExternalEquitySource}
            labelPlacement="start"
            style = {{marginLeft: "40px"}}
            control={<Checkbox 
                checked = {!!record.isExternalEquitySource}
                onClick = {() => this.updateExistingRecord(record, "isExternalEquitySource", !record.isExternalEquitySource)}
             />} 
            label={"External Equity"} />
            {!this.isRecordValid(record) && !!this.props.canShowErrors &&
            <>
            <br/>
            <span style={{color: "red", fontSize: "12px"}}>Required</span>
            </>
            }
        </div>
    )
}

getDisplayValueForRecord = (record) => {
    if(!record || !record.principleType) return null;
    if(record.principleType == "company"){
        let filtered = this.getPotentialCompanies().filter(x=>x.id == record.principleOwnerId);
        if(!filtered || !filtered[0]) return null;
        else return filtered[0].name || "Unknown Company";
    } else if (record.principleType == "individual") {
        let filtered = this.getPotentialContacts().filter(x=>x.id == record.principleOwnerId);
        if(!filtered || !filtered[0]) return null;
        if(filtered[0].firstName || filtered[0].lastName) return `${filtered[0].firstName} ${filtered[0].lastName}`
        else return "Unknown Individual"
    }
}

getSumOfOwnershipPercentages = () => {
    let sum = 0;
    this.getOwnershipRecords().forEach(x=> {
        sum += x.ownershipPercentage;
    });
    return sum;
}

isRecordValid = (record) => {
    let basicCheck = record.principleOwnerId 
        && (!!record.ownershipPercentage || record.ownershipPercentage === 0) 
        && record.ownershipPercentage <= 1;
    return basicCheck;
}

resetState = () => {
    this.setState({isAddDialogOpen: false, tempRecord: {principleType:"company"}, showErrorOnModal: false});
}

updateTempRecord = (fieldName, value) => {
    let record = this.state.tempRecord;
    record[fieldName] = value;
    this.setState({tempRecord: record});
}

updateExistingRecord = (record, fieldName, value) => {
    let baseRecord = null;
    if(record.id) {
        baseRecord = this.getOwnershipRecords().filter(x=>x.id === record.id)[0];
    } else if(record.tempId){
        baseRecord = this.getOwnershipRecords().filter(x=>x.tempId === record.tempId)[0];
    }
    baseRecord[fieldName] = value;
    baseRecord.id = null;
    if(!baseRecord.tempId) baseRecord.tempId = Math.floor(Math.random() * 99999999);
    this.forceUpdate();
    this.props.validateForm();
}

renderAddDialog = (formik) => {
    const handleClose = this.resetState;
    const handleAccept = () => {
        let didAdd = this.addOwnershipRecord(formik, this.state.tempRecord, false);
        if(didAdd) handleClose();
        else {
            this.setState({showErrorOnModal: true});
        }
    }
    let type = this.state.tempRecord.principleType || "company";
    return (
        <Dialog fullWidth={false} maxWidth={"md"} open={this.state.isAddDialogOpen} onClose={handleClose} id={"InfoDialog"}>
        <DialogTitle>Add Owner</DialogTitle>
        <StyledDialogIconButton onClick={handleClose}>
            <Close id="closeIcon" style={{ fontSize: 22 }} />
        </StyledDialogIconButton>
        <DialogContent style={{padding: "15px"}}>
            <div style={{display: "inline-block", marginRight: "30px",}}>
                <b>Type: </b>
                <Select
                    style={{marginLeft: "10px"}}
                    value={type}
                    onChange = {(e) => {
                            this.updateTempRecord("principleType", e.target.value);
                            this.updateTempRecord("principleOwnerId", null);
                            }}>

                    <MenuItem value="company">Company</MenuItem>
                    <MenuItem value="individual">individual</MenuItem>
                </Select>
            </div>
            <div style={{display: "inline-block"}}>
                <b>{type=="individual" ? "Contact" : "Company"}: </b>
                <FormControl style={{minWidth: "200px"}}>
                    <Select  style={{marginLeft: "10px"}} 
                            value={this.state.tempRecord.principleOwnerId} 
                            onChange = {(e) => {this.updateTempRecord("principleOwnerId", e.target.value)}}>
                    {type=="company" && this.getPotentialCompanies().map(x=><MenuItem value={x.id}>{x.name}</MenuItem>)}
                    {type=="individual" && this.getPotentialContacts().map(x=><MenuItem value={x.id}>{x.firstName} {x.lastName}</MenuItem>)}
                    </Select>
                </FormControl>
            </div>
            <div style={{display: "inline-block", marginLeft:"30px"}}>
                <b>Ownership Percent: </b>
                <VersitileInput 
                type = "percentNoDecimal"
                value = {this.state.tempRecord.ownershipPercentage*100}
                style={{maxWidth: "50px"}}
                onChange = {value => {
                    this.updateTempRecord("ownershipPercentage", value/100);
                }}
            />
            </div>
            <div style={{display: "inline-block", marginLeft:"30px"}}>
                <b>Is External: </b>
                <Checkbox 
                    checked = {this.state.tempRecord.isExternalEquitySource}
                    onClick = {() => {this.updateTempRecord("isExternalEquitySource", !this.state.tempRecord.isExternalEquitySource)}}
                />
            </div>
        </DialogContent>
        <DialogActions>
            {this.state.showErrorOnModal && <div style={{color: "red"}}>Invalid Input or Allocation Percentages Exceed 100%</div>}
            <PrimaryButton id="dialogOK" onClick={handleAccept}>{"OK"}</PrimaryButton>
        </DialogActions>
      </Dialog>
    )
}


}


const mapStateToProps = ({ authentication, contacts, companies }) => ({
    authentication,
    potentialContacts: contacts.contactsByCompany,
    potentialCompanies: companies.companiesByTypeId.ownershipSection,
  });

export default compose(
    connect(mapStateToProps, {
        getContactsByCompany,
        getCompaniesByTypeId,
    }), 
    withStyles(styles)
  )(OwnershipSection);
